import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { getFeatured } from '@helpers/helper.novelty'
import { ElementHTML } from '@helpers/helper.rendering'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Novelty, RealEstateDataPageComponentData } from 'types'

const Summary_Novelties_10 = (props: RealEstateDataPageComponentData) => {
  const { backgroundColor, title, titleElement, titleColor, global_data } = props
  const siteId = global_data.id
  const noveltyCard = global_data.content?.cardsNovelties?.type_id ?? '1'
  const Card = require(`@components/cardsNovelties/${noveltyCard}`)?.default

  const { data: allBlogData, isLoading } = useGetBlogsQuery({ site: siteId })

  return (
    <section
      id="summary-novelties"
      style={
        backgroundColor
          ? { backgroundColor, borderBottom: '1px solid #d6d6d6' }
          : { borderBottom: '1px solid #d6d6d6' }
      }
      className="p-y-config"
    >
      <Container fluid>
        <Row>
          <ElementHTML
            className={`mb-5`}
            children={title ?? ''}
            elementType={titleElement ?? 'h2'}
            style={titleColor ? { color: titleColor } : {}}
          />
        </Row>
        <Row>
          {isLoading
            ? [1, 2, 3].map((index) => (
                <Card
                  key={index}
                  skeleton={true}
                  global_data={global_data}
                />
              ))
            : getFeatured(allBlogData?.news)
                ?.slice(0, 4)
                .map((novelty: Novelty, index: number) => (
                  <Col lg={12}>
                    <Card
                      key={index}
                      tags={allBlogData?.tags}
                      novelty={novelty}
                      hidenAuthor={true}
                      global_data={global_data}
                      backgroundColor={'#FFF'}
                      skeleton={false}
                      backgroundSecondary={true}
                    />
                  </Col>
                ))}
        </Row>
      </Container>
    </section>
  )
}

export default Summary_Novelties_10
